import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getAPIBaseURL } from "../services/helpers"
import { getData, postData, updateData } from "../services/request"

const EditRequest = () => {
  const { postId } = useParams()
  const navigate = useNavigate()
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(true)
  const [btnState, setBtnState] = useState("Save changes")
  const [error, setError] = useState("")

  const load = async () => {
    setLoading(true)
    const url = `${getAPIBaseURL()}/v1/posts/${postId}`
    const headers = {}
    const res = await getData(url, headers, {})
    setLoading(false)
    if(res.error == ""){
      if(res.result.status === 200){
        setMessage(res.result.data?.data?.message || "")
      }else{
        setError(res.result.data?.message || 'Could not load request')
      }
    }else{
      setError(res.result?.data?.message || 'Network error')
    }
  }

  useEffect(()=>{ load() }, [postId])

  const validate = () => {
    if(!message || message.trim().length < 10){
      setError("Message must be at least 10 characters")
      return false
    }
    if(message.length > 5000){
      setError("Message must not exceed 5000 characters")
      return false
    }
    setError("")
    return true
  }

  const submit = async () => {
    if(!validate()) return
    setBtnState("Saving...")
    const url = `${getAPIBaseURL()}/v1/posts`
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    const params = new URLSearchParams()
    params.append('postId', postId)
    params.append('message', message)
    const res = await updateData(url, headers, params)
    setBtnState("Save changes")
    if(res.error == ""){
      if(res.result.status === 200){
        navigate('/dashboard/requests')
      }else{
        setError(res.result.data?.message || 'Update failed')
      }
    }else{
      setError(res.result?.data?.message || 'Network error')
    }
  }

  return (
    <div className="mx-auto max-w-3xl px-3 sm:px-0">
      <div className="rounded-lg bg-white shadow-sm border border-gray-200">
        <div className="border-b border-gray-200 bg-gray-50 px-4 py-4 sm:px-6 sm:py-6">
          <h2 className="text-lg font-semibold text-gray-900 sm:text-2xl">Edit Request</h2>
          <p className="mt-1 text-sm text-gray-600">Update the details of your medical request</p>
        </div>
        <div className="p-4 sm:p-6">
          {loading ? <div className="text-sm text-gray-500">Loading...</div> : (
            <>
              {error ? <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-700">{error}</div> : null}
              <label htmlFor="message" className="mb-2 block text-sm font-semibold text-gray-900">Message</label>
              <textarea id="message" value={message} onChange={(e)=>setMessage(e.target.value)} rows="6" className="block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm text-gray-900 transition-colors focus:border-black focus:outline-none focus:ring-2 focus:ring-black" />
              <div className="mt-4">
                <button onClick={()=>submit()} type="button" className="w-full rounded-lg bg-black px-6 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2">{btnState}</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default EditRequest


